import React, { Fragment, useMemo, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { CheckCircleOutline, Event, NotInterested, OpenInBrowser } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import ReactTable from 'components/ReactTable/ReactTable.js';
import moment from 'moment';
import { Checkbox, Tooltip } from '@material-ui/core';

import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import RegularButton from 'components/CustomButtons/Button';
import { wsCreate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  actionsBtn: {
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    float: 'right',
  },
  icon: {
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '5px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Estado', accessor: 'status', excelEnabled: false, width: 100 },
  { Header: 'Nombre usuario', accessor: 'SlpName' },
  { Header: 'DNI', accessor: 'dni', width: 100 },
  { Header: 'Celular', accessor: 'phone', width: 100 },
  { Header: 'Aperturado', accessor: 'days', width: 110 },
  { Header: 'Inicio', accessor: 'start_date', width: 100 },
  { Header: 'Cierre', accessor: 'end_date', width: 100 },
  { Header: 'Inicio operación', accessor: 'start_operation_at', width: 150 },
  { Header: 'Cierre operación', accessor: 'end_operation_at', width: 150 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 200 },
  { Header: 'Pendi.', accessor: 'pendient_orders', width: 80 },
  { Header: 'Proces.', accessor: 'process_orders', width: 80 },
  { Header: 'Anula.', accessor: 'anulled_orders', width: 80 },
  { Header: 'No orden', accessor: 'no_orders', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function WorkDays(props) {
  const classes = useStyles();
  const { title, type, permissions, works, reload, confirmChange } = props;
  const notOpenWorkDays = useMemo(() => works.filter(item => item.id === null), [works]);
  const [selectedWorkDays, setSelectedWorkDays] = useState([]);
  const [processing, setProcessing] = useState(false);

  const headers = type === 'NR' ? columns.filter((item) => item.accessor !== 'days') : columns;

  function toggleChecked(item) {
    setSelectedWorkDays(selected => {
      let newSelected = [...selected];
      if (newSelected.includes(item.base_seller_id)) {
        let index = newSelected.findIndex(idSeller => idSeller === item.base_seller_id);
        if (index !== -1) {
          newSelected.splice(index, 1);
        }
      } else {
        newSelected.push(item.base_seller_id);
      }
      return newSelected
    });
  }

  const [indeterminate, checked] = useMemo(() => {
    let indeterminate = false;
    let checked = false;
    if (notOpenWorkDays.length > 0 && selectedWorkDays.length === notOpenWorkDays.length) checked = true;
    if (selectedWorkDays.length > 0 && selectedWorkDays.length < notOpenWorkDays.length) indeterminate = true;
    return [indeterminate, checked];
  }, [selectedWorkDays, notOpenWorkDays]);

  function toggleAll() {
    if (indeterminate || checked) {
      setSelectedWorkDays([]);
      return;
    }
    setSelectedWorkDays(notOpenWorkDays.filter(item => item.id === null).map(item => item.base_seller_id));
  }

  async function onClickOpenWorkdays() {
    setProcessing(true);
    const res = await wsCreate('ordm/work-day/open-seller-work-days', { sellers: selectedWorkDays });
    setProcessing(false);
    if (res.success) {
      window.alert(res.message);
      reload();
    }
  }

  async function reopenAllSellerWorkDays() {
    setProcessing(true);
    const res = await wsCreate('ordm/work-day/reopen-all-seller-work-days', {});
    setProcessing(false);
    if (res.success) {
      window.alert(res.message);
      reload();
    }
  }

  async function closeAllSellerWorkDays() {
    setProcessing(true);
    const res = await wsCreate('ordm/work-day/close-all-seller-work-days', {});
    setProcessing(false);
    if (res.success) {
      window.alert(res.message);
      reload();
    }
  }

  return (
    <Card>
      <CardHeader icon>
        {type === 'NR' ? (
          <div style={{ display: 'flex' }}>
            <Checkbox
              margin="normal"
              indeterminate={indeterminate}
              checked={checked}
              onChange={toggleAll}
            />
            <h4 className={classes.cardIconTitle} onClick={toggleAll}>{title}</h4>
          </div>
        ) :
          <>
            <CardIcon color={props.themeContext.buttonColor}>
              <Event />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{title}</h4>
          </>
        }
      </CardHeader>
      <CardBody>
        {type === 'NR' ? (
          <FilterCustom
            getFilter={reload}
            zone
            bureau
            canal
            state
            nameState="status"
            optionValues={['O', 'C', 'N', '']}
            nameOptions={['Abierto', 'Cerrado', 'Sin abrir', 'Todos']}
            customControl={
              <Fragment>
                <RegularButton disabled={selectedWorkDays.length === 0 || processing} color="primary" onClick={onClickOpenWorkdays}>
                  Abrir jornadas seleccionadas {selectedWorkDays.length > 0 ? `(${selectedWorkDays.length})` : ''}
                </RegularButton>
                <RegularButton disabled={processing} color="warning" onClick={reopenAllSellerWorkDays}>
                  Reabrir todas las jornadas
                </RegularButton>
                <RegularButton disabled={processing} color="danger" onClick={closeAllSellerWorkDays}>
                  Cerrar todas las jornadas
                </RegularButton>
              </Fragment>
            }
          />
        ) : (
          <FilterCustom getFilter={(filter) => reload({ ...filter, all: 'Y' })} dateRange />
        )}

        <ReactTable
          defaultWidth={1500}
          colorRow={(item) => {
            return item.stateColor == 'O'
              ? '#15e84230'
              : item.stateColor == 'C'
                ? '#e8181826'
                : item.stateColor == 'N'
                  ? ''
                  : '';
          }}
          columns={headers}
          data={works.map((item, i) => {
            let data = {
              id: item.id,
              num: (
                <div className={classes.actionsBtn}>
                  {i + 1}
                  {item.status === 'N' && type === 'NR' ? (
                    <AllowedGuard permission={permissions.init}>
                      <Checkbox
                        margin="normal"
                        disabled={processing}
                        checked={selectedWorkDays.includes(item.base_seller_id)}
                        onChange={() => toggleChecked(item)}
                      />
                      <Tooltip title="Iniciar jornada">
                        <CheckCircleOutline
                          onClick={() => {
                            confirmChange({
                              id: item.id,
                              title: 'iniciar',
                              seller: item.SlpName,
                              entity: 'ordm/work-day/open-seller-work-day',
                              data: { base_seller_id: item.base_seller_id },
                            });
                          }}
                          className={classes.icon}
                          style={{ color: '#4caf50' }}
                        />
                      </Tooltip>
                    </AllowedGuard>
                  ) : undefined}

                  {item.status === 'O' ? (
                    <AllowedGuard permission={permissions.destroy}>
                      <Tooltip title="Cerrar jornada">
                        <NotInterested
                          onClick={() => {
                            confirmChange({
                              id: item.id,
                              title: 'cerrar',
                              seller: item.SlpName,
                              entity: 'ordm/work-day',
                              data: { status: 'C' },
                            });
                          }}
                          className={classes.icon}
                          style={{ color: 'red' }}
                        />
                      </Tooltip>
                    </AllowedGuard>
                  ) : undefined}

                  {item.status === 'C' ? (
                    <AllowedGuard permission={permissions.restore}>
                      <Tooltip title="Re-abrir jornada">
                        <OpenInBrowser
                          onClick={() => {
                            confirmChange({
                              id: item.id,
                              title: 'reabrir',
                              seller: item.SlpName,
                              entity: 'ordm/work-day',
                              data: { status: 'O' },
                            });
                          }}
                          className={classes.icon}
                          style={{ color: '#00acc1' }}
                        />
                      </Tooltip>
                    </AllowedGuard>
                  ) : undefined}
                </div>
              ),
              status: (
                <Badge
                  color={
                    item.status == 'O'
                      ? 'success'
                      : item.status == 'C'
                        ? 'danger'
                        : item.status == 'N'
                          ? 'info'
                          : ''
                  }
                >
                  {item.status == 'O'
                    ? 'Abierto'
                    : item.status == 'C'
                      ? 'Cerrado'
                      : item.status == 'N'
                        ? 'Sin abrir'
                        : '-'}
                </Badge>
              ),
              SlpName: item.SlpName,
              dni: item.dni,
              phone: item.phone || '-',
              days: item.start_date !== null ? moment().diff(moment(item.start_date), 'days') : '-',
              start_date: item.start_date || '-',
              end_date: item.end_date || '-',
              start_operation_at: item.start_operation_at || '-',
              end_operation_at: item.end_operation_at || '-',
              base_zone_description: item.base_zone_description,
              pendient_orders: item.pendient_orders || '-',
              process_orders: item.process_orders || '-',
              anulled_orders: item.anulled_orders || '-',
              no_orders: item.no_orders,
              actions: '',
              stateColor: item.status, // esto se usa para validacion interna nada +
            };
            if (type === 'NR') delete data.days;
            return data;
          })}
        />
      </CardBody>
    </Card>
  );
});
